import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar, Box, Typography, Link as MUILink } from '@mui/material';
import { useTheme } from '@mui/system';
import config from '@configFile';
import colors from '@utils/colors';

const BlogPostAuthorBio = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const color = isDarkMode ? colors.jdbLightPurple : 'primary.main';
  return (
    <Box sx={{ containerType: 'inline-size' }}>
      <Box
        sx={{
          paddingBottom: '24px',
          maxWidth: '400px',
          margin: '0 auto',
          '@container (min-width: 500px)': {
            maxWidth: '100%'
          }
        }}
      >
        <Box
          component="aside"
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            textAlign: 'center',
            gap: 2,
            padding: 3,
            borderRadius: 2,
            boxShadow: 2,
            backgroundColor: 'background.paper',
            margin: '0 auto',
            '@container (min-width: 500px)': {
              flexDirection: 'row',
              textAlign: 'left'
            }
          }}
        >
          {/* Author Image */}
          <Avatar
            src="https://jungledealsblog.com/jd-images/blog/2025-02-22/author-sarah.jpg"
            alt="Photo of Sarah Elizabeth"
            sx={{
              width: 80,
              height: 80,
              marginBottom: 0.2,
              '@container (min-width: 500px)': { marginBottom: 0 }
            }}
          />

          {/* Author Details */}
          <Box sx={{ '@container (min-width: 500px)': { flex: 1 } }}>
            <Typography
              variant="h6"
              component="h2"
              sx={{
                fontWeight: 'bold'
              }}
            >
              Sarah Elizabeth
            </Typography>
            <Typography
              variant="body2"
              component="h3"
              sx={{
                color: 'text.secondary'
              }}
            >
              Amazon Deals Expert
            </Typography>
          </Box>

          {/* Links + CTA — right side on wide containers */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              '@container (min-width: 500px)': {
                alignItems: 'flex-end',
                flexShrink: 0
              }
            }}
          >
            <MUILink
              component={Link}
              to="/author/sarah"
              onClick={() =>
                requestAnimationFrame(() =>
                  window.scrollTo({ top: 0, behavior: 'smooth' })
                )
              }
              sx={{
                color,
                display: 'inline-block',
                fontSize: '0.875rem',
                fontWeight: 'bold',
                '&:hover': { textDecoration: 'underline' }
              }}
            >
              Read more about Sarah →
            </MUILink>
            <MUILink
              href={config.TIKTOK_LINK}
              target="_blank"
              sx={{
                color,
                display: 'block',
                marginTop: 1,
                fontSize: '0.875rem',
                fontWeight: 'bold',
                '&:hover': { textDecoration: 'underline' }
              }}
            >
              Follow on TikTok →
            </MUILink>
            <MUILink
              component={Link}
              to="/email"
              onClick={() =>
                requestAnimationFrame(() =>
                  window.scrollTo({ top: 0, behavior: 'smooth' })
                )
              }
              sx={{
                display: 'inline-block',
                marginTop: 1.5,
                fontSize: '0.875rem',
                fontWeight: 'bold',
                padding: '6px 14px',
                backgroundColor: colors.amazonOrange,
                color: colors.neutralGray900,
                borderRadius: '4px',
                textDecoration: 'none',
                '&:hover': {
                  backgroundColor: colors.authorBioBg,
                  textDecoration: 'none'
                }
              }}
            >
              Get deals in your inbox →
            </MUILink>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BlogPostAuthorBio;
